/**
 * 微财税菜单-单据
 */

export default [
  {
    label: 'menu.cost001', //费用管控
    icon: 'icon-xieyi',
    id:'1',
    path: '/cost',
    permission: 'taxcloud5001',
    children: [
      // {
      //   label: '旧财税平台首页',
      //   icon: 'm-jiekuan',
      //   // path: '/cost/costServerCheckAction_serverCheckBill.action',
      //   path: '/contentIntro.action',
      //   permission: 'taxcloud5001',
      //   id:'1-0'
      // },
      {
        label: 'menu.cost002',//付款管理
        icon: 'm-fukuanshenqing',
        permission: 'taxcloud5005',
        id:'5005',
        path: '/costApplication',
        children: [
          {
            label: 'menu.cost003', //发票夹
            name: 'CostInvoiceFolder',
            path: '/costInvoiceFolder/costInvoiceList',
            permission: 'taxcloud5006',
            component: () => import (`@/views/cost/costInvoiceFolder/costInvoiceList.vue`),
            id:'5006new2',
          },
          {
            label: 'menu.cost004', //付款申请
            name: 'CostList',
            path: '/costApplication/costList',
            permission: 'taxcloud5006',
            component: () => import (`@/views/cost/costApplication/costList.vue`),
            id:'5006new1'
          },
          {
            label: 'menu.cost004', //付款申请
            // path: '/cost/costServerCheckAction_serverCheckBill.action',
            path: '/cost/costAction_toCostStatusListIndex.action',
            permission: 'taxcloudold5006',
            id:'5006old'
          },
          {
            label: 'menu.cost005', //差旅申请
            path: '/cost/costAction_toApplicationListIndex.action',
            permission: 'taxcloud5007',
            id:'5007'
          },
        ]
      },
      {
        label: 'menu.cost027',//票据
        icon: 'm-fukuanshenqing',
        permission: 'taxcloud1028',
        id:'1028',
        path: '/receipt',
        children: [
          {
            label: 'menu.cost028', //业务上传票据
            name: 'ReceiptList',
            path: '/receipt/toReceiptListPage.action',
            permission: 'taxcloud1029',
            id:'1029',
          },
          {
            label: 'menu.cost029', //报销单上传票据
            name: 'ReceiptUploadPage',
            path: '/receipt/toReceiptUploadPage.action',
            permission: 'taxcloud1030',
            id:'1030'
          },
        ]
      },
      {
        label: 'menu.cost006', //借款管理
        icon: 'm-jiekuan',
        permission: 'taxcloud6083',
        id:'6083',
        path: '/borrow',
        children: [
          {
            label: 'menu.cost007', //借款申请
            path: '/borrow/borrowAction_toBorrowStatusListIndex.action',
            permission: 'taxcloud6097',
            id:'6097'
          },
          {
            label: 'menu.cost008', //还款申请
            path: '/borrow/repayAction_toRepayStatusListIndex.action',
            permission: 'taxcloud6084',
            id:'6084'
          },
          {
            label: 'menu.cost009', // 借款/还款台账
            path: '/borrow/searchAction_toViewSearchInfo.action',
            permission: 'taxcloud6089',
            id:'6089'
          },
        ]
      },
      {
        label: 'menu.cost010', //供应商管理
        icon: 'm-hetongguanli',
        permission: 'taxcloud7024',
        id:'7024',
        path: '/contract',
        children: [
          {
            label: 'menu.cost011', // 供应商维护
            icon: 'm-gongyingshang',
            path: '/baseInfo/supplierManageForIndex.action',
            permission: 'taxcloud7029',
            id:'7029'
          },
          {
            label: 'menu.cost012', //供应商合同管理
            path: '/contract/contractAction_toContractStatusListIndex.action',
            permission: 'taxcloud7101',
            id:'7101'
          },
          {
            label: 'menu.cost013', //供应商合同结束申请
            path: '/contract/contract_toContractEndApplyStatusListIndex.action',
            permission: 'taxcloud7103',
            id:'7103',
            query: {
              contractType: 'c3VwcGxpZXI-'
            }
          },
        ]
      },
      {
        label: 'menu.cost014', //付款
        icon: 'm-fukuanguanli',
        permission: 'taxcloud5018',
        id:'5018',
        path: '/cashier/paid_listSet.action',
      },
      // {
      //   label: '付款',
      //   icon: 'm-fukuanguanli',
      //   permission: 'taxcloud7034',
      //   id:'7034',
      //   path: '/Payment',
      //   children: [
      //     {
      //       label: '报销付款',
      //       path: '/cashier/paid_listSetForBXJK.action',
      //       permission: 'taxcloud7035',
      //       id:'7035'
      //     },
      //     {
      //       label: '供应商支付/借款',
      //       path: '/cashier/paid_listSetForGYS.action',
      //       permission: 'taxcloud7036',
      //       id:'7036'
      //     },
      //   ]
      // },
      {
        label: 'menu.cost015', //待审批申请
        icon: 'm-daishenpi',
        permission: 'taxcloud5022',
        id:'5022new1',
        path: '/approve',
        children: [
          {
            label: 'menu.cost016', //待审批支付单
            path: '/costApplication/costApproveList',
            permission: 'taxcloud5022',
            id:'5022new2',
            component: () => import (`@/views/cost/costApplication/costApproveList.vue`)
          },
          {
            label: 'menu.cost017', //其他待审批
            path: '/cost/manageCostAction_toManageApproveIndex.action',
            permission: 'taxcloud5022',
            id:'5022new3'
          },
        ]
      },
      {
        label: 'menu.cost015', //待审批申请
        icon: 'm-daishenpi',
        permission: 'taxcloudold5022',
        id:'5022old',
        path: '/cost/manageCostAction_toManageApproveIndex.action',
      },
      {
        label: 'menu.cost018', //我的审批记录
        icon: 'm-yishenpi',
        permission: 'taxcloud5023',
        id:'5023new1',
        path: '/myapprove',
        children: [
          {
            label: 'menu.cost019', //支付单审批记录
            path: '/costApplication/myCostApproveList',
            permission: 'taxcloud5023',
            id:'5023new2',
            component: () => import (`@/views/cost/costApplication/myCostApproveList.vue`),
          },
          {
            label: 'menu.cost020', //其他审批记录
            path: '/cost/cost/manageCostAction_toManageApproveIndexMy.action',
            permission: 'taxcloud5023',
            id:'5023new3'
          }
        ]
      },
      {
        label: 'menu.cost018', //我的审批记录
        icon: 'm-yishenpi',
        permission: 'taxcloudold5023',
        id:'5023old',
        path: '/cost/cost/manageCostAction_toManageApproveIndexMy.action',
      },
      {
        label: 'menu.cost021', //财务审批
        icon: 'm-caiwushenpi',
        permission: 'taxcloud5011',
        id:'5011',
        path: '/financial',
        children: [
          {
            label: 'menu.cost022', //财务查询
            path: '/financial/financialInquiryIndex.action',
            permission: 'taxcloud5017',
            id:'5017'
          },
          {
            label: 'menu.cost023', //出纳审核
            path: '/financial/financialAudit_toExamineIndex.action',
            permission: 'taxcloud5013',
            id:'5013'
          },
          {
            label: 'menu.cost024', //财务经理复核
            path: '/financial/financialAudit_toReviewIndex.action',
            permission: 'taxcloud5012',
            id:'5012'
          },
          {
            label: 'menu.cost025', //我的审核记录
            path: '/financial/financialRecordIndex.action',
            permission: 'taxcloud5015',
            id:'5015'
          },
          // {
          //   label: '我的复核记录',
          //   path: '/financial/financialRecordIndex.action',
          //   permission: 'taxcloud5016',
          //   id:'5016'
          // },
          {
            label: 'menu.cost026', //记账文件管理
            path: '/financial/accountFileIndex.action',
            permission: 'taxcloud5014',
            id:'5014'
          },
        ]
      },
    ]
  }
];

